// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"f56de937","123":"3c5ca1b0","125":"fa6e2e6b","148":"e96cedea","257":"beebb995","274":"294cd796","570":"a6768c82","579":"29aea742","596":"ecd6ff70","692":"a4b9d928","795":"b838c038","835":"697bd701","846":"f13bfd94","881":"bad5d579"}[chunkId] + ".chunk.js";
};